(function() {
  var MultiDialog;

  MultiDialog = App.loadClass('core::MultiDeleteDialog');

  $(function() {
    return $.widget('custom.multidelete', {
      options: {
        targetSelector: null,
        delModeClass: 'alert alert-success',
        delSelectClass: 'alert alert-error',
        delUrl: null,
        dataKey: 'db_id',
        dataName: 'db_name',
        afterHidden: function() {
          return void 0;
        },
        onStart: function() {
          return void 0;
        }
      },
      _create: function() {
        var ref, ths;
        ths = this;
        this.options.targetSelector = (ref = this.options.targetSelector) != null ? ref : this.element.data('multidelete-selector');
        if ($(this.options.targetSelector).children().hasClass('dataTables_empty')) {
          this.element.prop('disabled', true);
        }
        return this.element.click(function() {
          var inDeleteMode, ref1;
          inDeleteMode = (ref1 = ths.mode) != null ? ref1 : false;
          if (!inDeleteMode) {
            ths.startDelete();
            return ths.mode = true;
          } else {
            ths.finishDelete();
            return ths.mode = false;
          }
        });
      },
      _setOption: function() {
        return void 0;
      },
      inDeleteMode: function() {
        var ref;
        return (ref = this.mode) != null ? ref : false;
      },
      destroy: function() {
        return void 0;
      },
      startDelete: function() {
        var target, ths;
        ths = this;
        this.selectedCount = 0;
        this.prevHtml = this.element.html();
        this.element.html("<i class='fa fa-remove'></i> Cancel Deletion");
        ths.options.onStart();
        target = $(this.options.targetSelector);
        this.restoreStriped = false;
        if (target.parents('table').hasClass('table-striped')) {
          this.restoreStriped = true;
          target.parents('table').removeClass('table-striped');
        }
        target.each(function() {
          return $(this).addClass(ths.options.delModeClass);
        });
        return target.bind('click', function() {
          var ref, selected;
          selected = (ref = $(this).data('multidelete-selected')) != null ? ref : false;
          if (!selected) {
            ths.selectedCount += 1;
            $(this).addClass('multidelete-del').addClass(ths.options.delSelectClass);
            $(this).removeClass(ths.options.delModeClass);
            $(this).data('multidelete-selected', true);
          } else {
            ths.selectedCount -= 1;
            $(this).removeClass('multidelete-del').removeClass(ths.options.delSelectClass);
            $(this).addClass(ths.options.delModeClass);
            $(this).data('multidelete-selected', false);
          }
          if (ths.selectedCount > 0) {
            return ths.element.html("<i class='fa fa-trash-alt'></i> Delete Selected");
          } else {
            return ths.element.html("<i class='fa fa-remove'></i> Cancel Deletion");
          }
        });
      },
      finishDelete: function() {
        var dlg, saveData, target, ths, total;
        ths = this;
        target = $(this.options.targetSelector).filter('.multidelete-del');
        total = target.length;
        if (total === 0) {
          ths._cleanUp();
          return 0;
        }
        saveData = {
          objects: []
        };
        target.each(function() {
          var el;
          el = $(this);
          return saveData.objects.push({
            id: el.data(ths.options.dataKey),
            name: el.data(ths.options.dataName),
            element: el
          });
        });

        /*
            This... is not so great. I want this to be subhandled somehow.
            But that kind of implies that multidelete should somehow be a subhandler
            of it's own. Maybe instead of a jquery widget, it becomes a subhandler you init
            that automatically includes the multidelete button, and you set some attributes
            to tell it which table to point at and such.
         */
        dlg = new MultiDialog();
        dlg.saveUrl = ths.options.delUrl;
        dlg.saveData = saveData;
        dlg.multi_widget = this;
        return dlg.init();
      },
      _cleanUp: function() {
        var target, ths;
        ths = this;
        ths.options.afterHidden();
        this.element.html(this.prevHtml);
        target = $(this.options.targetSelector);
        target.unbind('click');
        if (this.restoreStriped) {
          target.parents('table').addClass('table-striped');
        }
        return target.each(function() {
          $(this).removeClass(ths.options.delModeClass);
          $(this).removeClass(ths.options.delSelectClass);
          $(this).removeClass('multidelete-del');
          return $(this).removeData('multidelete-selected');
        });
      }
    });
  });

}).call(this);
